module.exports = __webpack_public_path__ + "img/defaultAvt.6997ad7b.jpg";